import React from "react";

import {
	HeaderLogo,
	HeaderMenuToggleButton,
	HeaderSpecialLinks,
	HeaderTop,
} from "../components";
import { useRootAppStore } from "@hooks";
import { THEME_SETTINGS } from "@theme-settings";
import HeaderFailedLoginsCheckButton from "../components/HeaderFailedLoginsCheckButton";

export default function MainPageHeader() {
	const {
		userAuthStore: { isLoggedIn },
	} = useRootAppStore();

	return (
		<header className="l--header l__header">
			<div className="header header--root">
				<div className="header__top">
					<HeaderTop />

					<HeaderSpecialLinks />
				</div>

				<div className="header__main header--root__main">
					<HeaderLogo />

					<nav className="header__nav">
						{isLoggedIn &&
							THEME_SETTINGS.failedLoginReport.isEnabled && (
								<HeaderFailedLoginsCheckButton />
							)}
						<HeaderMenuToggleButton />
					</nav>
				</div>
			</div>

			<div id="account24HourLockPopup" />
		</header>
	);
}
